// extracted by mini-css-extract-plugin
module.exports = {"container":"subGroupsMenu_container__1inE-","subGroupOpening":"subGroupsMenu_subGroupOpening__2CbbY","arrow":"subGroupsMenu_arrow__1lQIk","bodyWrapper":"subGroupsMenu_bodyWrapper__3CMGK","body":"subGroupsMenu_body__2AdYa","subGroup":"subGroupsMenu_subGroup__tmDGR","title":"subGroupsMenu_title__9XETi"};
    if(module.hot) {
      // 1785568564944
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  